import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import ru from 'vuetify/lib/locale/ru'

Vue.use(Vuetify);

export default new Vuetify({
	lang: {
		locales: { ru },
		current: 'ru',
	},
	theme: {
		dark: false,
		themes: {
			light: {
				primary: '#e66575',
				secondary: '#b0bec5',
				accent: '#e66575',
				error: '#b71c1c',
			},
		},
	},
});
